export class DevicesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async register(payload) {
    return this.#http.post('api/devices/register', payload);
  }

  async heartbeat(payload) {
    return this.#http.post('api/devices/heartbeat', payload);
  }

  async otaPing(payload) {
    return this.#http.post('api/devices/ota-ping', payload);
  }
}
